import axios from 'axios';

/**
    * @function facilitiesListService
    * @params
    * @description used to get facilities list
*/
export const facilitiesListService = () => {
    try {
        return axios.get(`/kiosk/sports_facility`);
    } catch (error) {
        return error;
    }
}

/**
    * @function complexBookingService
    * @params id, date
    * @description
*/
export const complexBookingService = ({ id, date }) => {
    try {
        return axios.post(`/kiosk/booking`, {
            sports_facility_id: id,
            date
        });
    } catch (error) {
        return error;
    }
}

/**
    * @function getCourtService
    * @params sports_facility_id, date, start, no_of_hours
    * @description used to get court
*/
export const getCourtService = async ({ sports_facility_id, date, start, no_of_hours }) => {
    try {
        const result = await axios.post(`/kiosk/booking/get-courts`, {
            sports_facility_id,
            date,
            start,
            no_of_hours
        });
        return result;
    } catch (error) {
        return error;
    }
}

/**
    * @function checkBookingService
    * @params sports_facility_id, date, start, no_of_hours, court_nos, is_deposit
    * @description used to check booking
*/
export const checkBookingService = async ({ sports_facility_id, date, start, no_of_hours, court_nos, is_deposit }) => {
    try {
        const result = await axios.post(`/kiosk/booking/check`, {
            sports_facility_id,
            date,
            start,
            no_of_hours,
            type: 'WALK_IN',
            court_nos,
            dynamic_discount: null,
            is_deposit
        });
        return result;
    } catch (error) {
        return error;
    }
}

/**
    * @function bookingLockedService
    * @params sports_facility_id, court_nos, date, start, no_of_hours, uuid
    * @description
*/
export const bookingLockedService = async ({ sports_facility_id, court_nos, date, start, no_of_hours }) => {
    try {
        const result = await axios.post(`/api/v1/sports-complex/booking/lock-slot`, {
            sports_facility_id,
            type: 'WALK_IN',
            court_nos,
            date,
            start,
            no_of_hours,
            dynamic_discount: null
        });
        return result;
    } catch (error) {
        return error;
    }
}

/**
    * @function bookingService
    * @params sports_facility_id, court_nos, date, start, no_of_hours, is_deposit, user_name, user_email, user_phone
    * @description used to book
*/
export const bookingService = async ({ sports_facility_id, court_nos, date, start, no_of_hours, is_deposit, user_name, user_email, user_phone }) => {
    try {
        const result = await axios.post(`/kiosk/booking/add`, {
            sports_facility_id,
            type: 'walkin',
            court_nos,
            date,
            start,
            no_of_hours,
            is_deposit,
            dynamic_discount: null,
            user_name,
            user_email,
            user_phone
        });
        return result;
    } catch (error) {
        return error;
    }
}

/**
    * @function bookingReceiptService
    * @params
    * @description used to get receipt url
*/
export const bookingReceiptService = (hash) => {
    try {
        return axios.get(`/kiosk/booking/receipt/${hash}`);
    } catch (error) {
        return error;
    }
}


/**
    * @function allVariableService
    * @params
    * @description used to get all variable
*/
export const allVariableService = () => {
    try {
        return axios.get(`/kiosk/variable/all`);
    } catch (error) {
        return error;
    }
}